import { type FC } from "react";
import SweepstakesButton from "../SweepstakesButton";
import { Body, Eyebrow, Headline, LineBreaks } from "../SweepstakesText";
import { type PopupCopy } from "../popupContent";

const IntroStep: FC<{
  copy: PopupCopy["intro"];
  onAdvance: () => void;
}> = ({ copy, onAdvance }) => (
  <div className="flex w-full flex-col items-center gap-5 text-center md:gap-6 xl:gap-8 2xl:gap-10">
    <div className="flex w-full flex-col items-center gap-2">
      <Eyebrow>{copy.eyebrow}</Eyebrow>
      <Headline>{copy.headline}</Headline>
      {copy.body && (
        <Body>
          <LineBreaks value={copy.body} />
        </Body>
      )}
    </div>
    <SweepstakesButton onClick={onAdvance}>{copy.cta}</SweepstakesButton>
  </div>
);

export default IntroStep;
